<template>
  <BaseTableView :head="tableHead">
    <DocumentsShowTableItem v-for="(item, key) in items" :key="key + 'items'" :item="item" :downloadPageData="downloadPageData"/>
    <DocumentsShowTableItem
      v-for="(item, key) in itemsUpload"
      :key="key + 'itemsUpload'"
      :item="item"
      :upload="true"
    />
  </BaseTableView>
</template>

<script>
import DocumentsShowTableItem from 'components/documents/show/DocumentsShowTableItem'
export default {
  name: 'DocumentsShowTable',
  props: ['items', 'itemsUpload', 'workAreaList', 'downloadPageData'],
  components: { DocumentsShowTableItem },
  data() {
    return {
      documentsData: [],
      tableMin: false,
    }
  },
  computed: {
    itemsUploadSort() {
      return this.itemsUpload.map((f) => f).sort()
    },
    tableHead() {
      let array = [
        {
          text: this.localStorage.translations.pages['setting-free_documents']['tables']['name'],
        },
        {
          text: this.localStorage.translations.pages['setting-free_documents']['tables'][
            'date_added'
          ],
        },
        { active: true },
      ]
      if (this.$route.meta.requestType === 'admin') {
        array[0].sort = {
          name: 'name',
          value:
            this.$route.query.sort_param && this.$route.query.sort_param === 'name'
              ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                ? 'asc'
                : 'desc'
              : 'desc',
        }
      }
      return array
    },
  },
  methods: {
    onItemData(data) {
      this.documentsData.push(data)
      this.$emit('documentsTableEditData', this.documentsData)
    },
    sort(array) {
      return array
        .map((f) => f)
        .sort((a, b) => {
          return b.key - a.key
        })
    },
  },
}
</script>
